<script setup lang="ts">
import {computed, ref, watch} from 'vue';

interface Props {
	buttonsPerRow: number;
	totalButtons: number;
	selectedItem?: number;
}

const props = defineProps<Props>();
const activeItem = ref(0);

const col = computed(() => props.selectedItem % props.buttonsPerRow);

watch( props, ({ selectedItem } ) => {
	activeItem.value = selectedItem;
} );

</script>

<template>
	<div class="button-strip">
		<slot></slot>
	</div>
</template>

<style scoped lang="scss">
.button-strip {
	@include hide-scrollbars;
	--size: 80px;
	display: grid;
	grid-template-columns: repeat(v-bind('totalButtons'), var(--size));
	height: var(--size);
	width: calc(100% + (var(--accordion-item-px) * 2));
	margin-inline-start: calc(var(--accordion-item-px) * -1);
	padding-inline: var(--accordion-item-px);
	overflow: auto;
	overscroll-behavior-x: contain;
	position: relative;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: var(--accordion-item-px);
		z-index:-1;
		width: var(--size);
		height: var(--size);
		background-color: $brand-blue-background;
		transform: translateX(calc(v-bind('col') * 100%));
		will-change: transform;
		transition: transform .2s ease-in-out;
	}

	:deep(.button) {
		width: var(--size);
		height: var(--size);
		border: 1px solid $border-color;
		border-right-width: 0;
		border-radius: 0;
		color: $brand-blue-dark;

		&:first-child {
			border-top-left-radius: 3px;
			border-bottom-left-radius: 3px;
		}
		&:last-child {
			border-top-right-radius: 3px;
			border-bottom-right-radius: 3px;
			border-right-width: 1px;
		}
		@include hover-focus-style {
			border-color: $border-color;
		}
	}

	:deep(.button--active) {
		border: 1px solid $brand-blue-dark;
		width: calc(var(--size) + 1px);
		position: relative;
		z-index: 1;
		@include hover-focus-style {
			border-color: $brand-blue-dark;
		}
		&:last-child {
			width: var(--size);
		}
	}
}
</style>
